var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiftOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "ionicon",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 104v56h56a56 56 0 10-56-56zM256 104v56h-56a56 56 0 1156-56z",
    fill: "none",
    stroke: "white",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 32
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 160,
    width: 384,
    height: 112,
    rx: 32,
    ry: 32,
    fill: "none",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 32
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M416 272v144a48 48 0 01-48 48H144a48 48 0 01-48-48V272M256 160v304",
    fill: "none",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 32
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftOutline);
export default __webpack_public_path__ + "static/media/gift-outline.129042e4d8a8360d62f9840508f44d6a.svg";
export { ForwardRef as ReactComponent };